// src/components/lead/sections/InterestTimelineSection.tsx
/*interest level & timeline grid*/
import type { ExtractedLeadV2 } from "../../../types/lead";
import type { UpdateLeadFieldFn } from "../../../types/leadActions";

type Props = {
  e: ExtractedLeadV2;
  updateCurrentLeadField: UpdateLeadFieldFn;
};

export function InterestTimelineSection({ e, updateCurrentLeadField }: Props) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
      <div>
        <div className="text-gray-500 text-xs uppercase tracking-wide mb-1">
          Interest Level
        </div>
        <select
          className="w-full border rounded-lg px-3 py-2 text-sm"
          value={e.interest_level || ""}
          onChange={(ev) =>
            updateCurrentLeadField(
              "interest_level",
              ev.target.value as ExtractedLeadV2["interest_level"]
            )
          }
        >
          <option value="">Select…</option>
          <option value="hot">Hot</option>
          <option value="warm">Warm</option>
          <option value="cold">Cold</option>
        </select>
      </div>

      <div>
        <div className="text-gray-500 text-xs uppercase tracking-wide mb-1">
          Ready To Buy
        </div>
        <select
          className="w-full border rounded-lg px-3 py-2 text-sm"
          value={e.ready_to_buy_timeline || ""}
          onChange={(ev) =>
            updateCurrentLeadField(
              "ready_to_buy_timeline",
              (ev.target.value || null) as ExtractedLeadV2["ready_to_buy_timeline"]
            )
          }
        >
          <option value="">Select…</option>
          <option value="this_week">This week</option>
          <option value="this_month">This month</option>
          <option value="1-3_months">1–3 months</option>
          <option value="3-6_months">3–6 months</option>
          <option value="6+_months">6+ months</option>
          <option value="unknown">Unknown</option>
        </select>
      </div>
    </div>
  );
}
